import React from 'react'

const LoadingSkeleton = ({ smallImages = true, count = 10 }) => {
  const skeletonItems = Array.from({ length: count }, (_, index) => index)

  return (
    <div className="w-full px-2 sm:px-4 md:px-4">
      <div>
        {skeletonItems.map((item) => (
          <div key={item} className="mb-4">
            <div className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden">
              <div className="p-3 sm:p-4 md:p-6">
                <div className="flex flex-col lg:flex-row lg:gap-6">
                  {/* Image Gallery Skeleton */}
                  <div className={`${smallImages ? 'lg:w-[250px]' : 'lg:w-[400px]'} w-full mb-3 lg:mb-0`}>
                    <div className="rounded-lg overflow-hidden">
                      <div className="w-full h-48 sm:h-56 lg:h-64 bg-gray-200 animate-pulse"></div>
                    </div>
                  </div>

                  {/* Item Details Skeleton */}
                  <div className="flex-1 min-w-0">
                    <div className="space-y-3">
                      {/* Title skeleton */}
                      <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>

                      {/* Location skeleton */}
                      <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>

                      {/* Price skeleton */}
                      <div className="h-6 bg-gray-200 rounded w-1/3 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/4 animate-pulse"></div>

                      {/* Property details skeleton */}
                      <div className="space-y-2">
                        <div className="h-3 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2 animate-pulse"></div>
                      </div>
                    </div>
                  </div>

                  {/* Tags and date skeleton */}
                  <div className="mt-3 lg:mt-0 lg:w-32">
                    <div className="space-y-2">
                      <div className="h-5 bg-gray-200 rounded w-16 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-24 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LoadingSkeleton
